// removed by extract-text-webpack-plugin
module.exports = {"councilMapWrapper":"council-map-container-module__councilMapWrapper___2eUiQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/council-map-container/council-map-container.module.scss
// module id = 832
// module chunks = 0 1